import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FileText, Code } from "lucide-react";
import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { Icd10CodeRules } from "./Icd10CodeRules";
import { Opcs4CodeRules } from "./Opcs4CodeRules";

export const ClinicalCodeRulesPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams.get("tab") || "icd10";

  const handleTabChange = (value: string) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("tab", value);
      return newParams;
    });
  };

  // Validate tab value and redirect to default if invalid
  useEffect(() => {
    if (currentTab !== "icd10" && currentTab !== "opcs4") {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set("tab", "icd10");
        return newParams;
      });
    }
  }, [currentTab, setSearchParams]);

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5" />
            Clinical Code Rules
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs value={currentTab} onValueChange={handleTabChange} className="w-full">
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="icd10" className="flex items-center gap-2">
                <Code className="h-4 w-4" />
                ICD-10 Code Rules
              </TabsTrigger>
              <TabsTrigger value="opcs4" className="flex items-center gap-2">
                <Code className="h-4 w-4" />
                OPCS-4 Code Rules
              </TabsTrigger>
            </TabsList>
            <TabsContent value="icd10" className="mt-6">
              <Icd10CodeRules />
            </TabsContent>
            <TabsContent value="opcs4" className="mt-6">
              <Opcs4CodeRules />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};
